<template>
  <div :class="$style.container">
    <ContactComponent
      v-for="contact in searchResults"
      :key="contact.crmId"
      :contact="contact"
      :class="$style.contactsContainer" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ContactComponent from './ContactComponent'

const { mapState } = createNamespacedHelpers('dialer')

export default {
  components: {
    ContactComponent
  },
  computed: {
    ...mapState([
      'searchResults'
    ])
  }
}
</script>

<style module lang="less" src="./ContactsComponent.less"></style>



// WEBPACK FOOTER //
// ContactsComponent.vue?5497df21